import {paymentTypes} from "../constants/constants";

export const resolvePaymentType = paymentType => {
    const paymentTypeName = paymentTypes.find(pt => pt.value == paymentType);
    return (
        paymentTypeName || {value: "unknown", label: "Belirtilmemiş", translation_key: "unknown"}
    );
};
